function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefencer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1442_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6742 5.30156C19.6375 4.21562 16.1008 2.65859 12.8727 0.651562L13.0422 0.749219C12.8899 0.646875 12.7024 0.585938 12.5008 0.585938C12.2992 0.585938 12.1117 0.646875 11.9555 0.751563L11.9594 0.749219C8.90002 2.65625 5.36331 4.21328 1.60627 5.23594L1.32659 5.30078C0.898462 5.41094 0.587524 5.79297 0.587524 6.24844C0.587524 6.32578 0.596899 6.40156 0.614087 6.47422L0.612524 6.46797C1.03518 8.30547 4.96487 24.4141 12.5016 24.4141C20.0391 24.4141 23.9672 8.30547 24.3914 6.46797C24.4071 6.40234 24.4164 6.32656 24.4164 6.24922C24.4164 5.79375 24.1047 5.41094 23.6828 5.30313L23.6758 5.30156H23.6742ZM12.5 22.4609C7.72737 22.4609 4.04143 11.9969 2.73674 6.93906C6.45237 5.86563 9.69299 4.42969 12.6836 2.62344L12.5 2.72656C15.3071 4.42969 18.5469 5.86563 21.9727 6.86719L22.2625 6.93984C20.9594 11.9984 17.2727 22.4609 12.5 22.4609ZM9.38049 13.0375C9.20393 12.8625 8.96096 12.7539 8.69221 12.7539C8.15315 12.7539 7.71565 13.1914 7.71565 13.7305C7.71565 14.0016 7.82581 14.2469 8.00393 14.4234L9.90862 16.3141L9.92581 16.3258L9.93752 16.3422C9.99534 16.3898 10.0617 16.4312 10.1328 16.4641L10.1383 16.4664C10.1672 16.4867 10.2 16.5078 10.2344 16.5266L10.2399 16.5289C10.3453 16.5727 10.468 16.5984 10.5969 16.5984C10.7336 16.5984 10.8633 16.5695 10.9805 16.518L10.9742 16.5203C11.0156 16.4961 11.0508 16.4727 11.0836 16.4469L11.0813 16.4484C11.161 16.4094 11.2289 16.3625 11.2906 16.3086L11.2899 16.3094L11.3016 16.2914L11.3172 16.2805L17.0281 10.0375C17.1867 9.86406 17.2844 9.63281 17.2844 9.37812C17.2844 8.83906 16.8477 8.40156 16.3078 8.40156C16.0227 8.40156 15.7664 8.52344 15.5883 8.71797L15.5875 8.71875L10.5633 14.2109L9.38049 13.0375Z",
    fill: "#448945",
    style: {
      fill: "#448945",
      fill: "color(display-p3 0.2667 0.5373 0.2706)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1442_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefencer);
export default __webpack_public_path__ + "static/media/defencer.4b9da8910d9f491c4b0053c5d0f6dd5b.svg";
export { ForwardRef as ReactComponent };